import { Size } from '@ts/css'
import { isNumber } from 'lodash'

export const ensureSizeUnit = (prop: Size) => (isNumber(prop) ? `${prop}px` : prop)

export default ensureSizeUnit
